import React, { useEffect, useState } from 'react';
import { 
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Grid
} from '@mui/material';
import { ActionButton } from '../../buttons/ButtonStyles';

export default function RenameBoardModal({ name, open, setOpen, onSave }) {
  const [boardName, setBoardName] = useState<string>("");
  const [newBoardName, setNewBoardName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSaving(false);
  };

  const handleSave = async () => {
    setSaving(true);
    if (newBoardName.trim()) {
      setBoardName(newBoardName);
      await onSave(newBoardName);
    }
    setOpen(false);
    setSaving(false);
  };

  useEffect(() => {
    setBoardName(name);
  },[name]);

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle className="text-center font-bold">
          Rename the Board
        </DialogTitle>
        
        <DialogContent>
          <Grid className="py-2">
            <Typography variant="body1" className="text-gray-500">
              Current: {boardName}
            </Typography>
            
            <Grid className="flex items-center mt-4">
              <Typography variant="body1" className="mr-2" sx={{ marginBottom: '4px' }}>
                New:
              </Typography>
              <TextField
                autoFocus
                size="small"
                fullWidth
                placeholder="Type in New Name"
                value={newBoardName}
                onChange={(e) => setNewBoardName(e.target.value)}
                autoComplete='off'
              />
            </Grid>
          </Grid>
        </DialogContent>
        
        <DialogActions className="p-2 flex justify-between" sx={{ padding: '24px' }}>
            <ActionButton variant="contained" onClick={handleClose}>
                Cancel
            </ActionButton>
            <ActionButton disabled={saving} variant="contained" onClick={handleSave}>
                {saving ? "Saving..." : "Save"}
            </ActionButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}